import { Component, Story, Knobs, Accents, Icons } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  submitButtonText: {
    default: 'Save',
    editor: 'textbox',
  },
  submitButtonAccent: {
    default: 'viridiangreen',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  submitButtonIcon: {
    default: 'Save',
    editor: 'dropdown',
    editorOptions: [''].concat(Icons),
  },
  submitButtonIconAccent: {
    default: 'white',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
  submitButtonAlign: {
    default: 'left',
    editor: 'dropdown',
    editorOptions: ['left', 'right', 'center'],
  },
};

const StandardStory: Story = {
  title: 'Standard',
  description: 'A tag-form where you can change all the attributes',
  coreComponent: {
    html: `<tag-form {{...knobs}}'>
<tag-form-group>
  <tag-edit-field name='type' label='Type' editor='dropdown'>
    <tag-edit-field-option selected></tag-edit-field-option>
    <tag-edit-field-option>Fall on Same Level</tag-edit-field-option>
    <tag-edit-field-option>Fall from Height</tag-edit-field-option>
    <tag-edit-field-option>Struck by Moving Object</tag-edit-field-option>
    <tag-validation rule='required'></tag-validation>
  </tag-edit-field>
</tag-form-group>

<tag-form-group>
  <tag-edit-field name='date' label='Date' type='date' editor='datepick' default-value='{{today}}'>
    <tag-validation rule='required'></tag-validation>
  </tag-edit-field>
</tag-form-group>

<tag-form-group>
  <tag-edit-field name='description' label='Description' editor='multilinetextbox'>
    <tag-validation rule='required'></tag-validation>
    <tag-validation rule='maxLength' args='1000'></tag-validation>
  </tag-edit-field>
</tag-form-group>

<tag-form-group>
  <tag-edit-field name='reportedBy' label='Reported By'>
      <tag-validation rule='required'></tag-validation>
      <tag-validation rule='maxLength' args='100'></tag-validation>
  </tag-edit-field>
</tag-form-group>
</tag-form>`,
    knobs: PlaygroundKnobs,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    let inline=false;
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    today = mm + '/' + dd + '/' + yyyy;
   return (

     <TagForm{{...knobs}} inline={inline}
      >
     <TagFormGroup >
       <TagEditField
         name="type"
         label="Type"
         editor="combobox"
         options={[
           { label: 'Fall on Same Level', value: '1' },
           { label: 'Fall from Height', value: '2' },
           { label: 'Struck by Moving Object', value: '3' },
         ]}
         validation={[{ rule: 'required' }]}
       />
     </TagFormGroup>
     <TagFormGroup >
   <TagEditField
     name="date"
     label="Date"
     editor="datepick"
     validation={[{ rule: 'required' }]}
     defaultValue={today}
   />
 </TagFormGroup>
 <TagFormGroup  >
   <TagEditField
     name="description"
     label="Description"
     editor="multilinetextbox"
     validation={[{ rule: 'required' }, { rule: 'maxLength', args: '1000' }]}
   />
 </TagFormGroup>

 <TagFormGroup >
   <TagEditField
     name="reportedBy"
     editor="textbox"
     validation={[{ rule: 'required' }]}
     label="Reported By"
   />
 </TagFormGroup>
   </TagForm>

   )};`,
    knobs: PlaygroundKnobs,
  },
};

const InlineStory: Story = {
  title: 'Inline',
  description: 'An example with an inline form',
  coreComponent: {
    html: `<tag-form
  inline
  submit-button-text='Save'
  submit-button-icon='Save'
  submit-button-icon-accent='white'
  submit-button-accent='viridiangreen'
  submit-button-align='left'
>
  <tag-form-group inline>
    <tag-edit-field name='type' label='Type' editor='combobox' placeholder='(Select)' inline>
      <tag-edit-field-option selected></tag-edit-field-option>
      <tag-edit-field-option>Fall on Same Level</tag-edit-field-option>
      <tag-edit-field-option>Fall from Height</tag-edit-field-option>
      <tag-edit-field-option>Struck by Moving Object</tag-edit-field-option>
      <tag-validation rule='required'></tag-validation>
    </tag-edit-field>
    <tag-edit-field name='date' label='Date' type='date' editor='datepick' inline>
      <tag-validation rule='required'></tag-validation>
      <tag-validation rule='maxLength' args='1000'></tag-validation>
    </tag-edit-field>
  </tag-form-group>

  <tag-form-group inline>
    <tag-edit-field name='description' label='Description' editor='multilinetextbox' inline>
      <tag-validation rule='required'></tag-validation>
      <tag-validation rule='maxLength' args='1000'></tag-validation>
    </tag-edit-field>
  </tag-form-group>

  <tag-form-group inline>
    <tag-edit-field name='reportedBy' label='Reported By' editor='combobox' placeholder='(Select)' inline>
      <tag-edit-field-option>Bob</tag-edit-field-option>
      <tag-edit-field-option>Jane</tag-edit-field-option>
      <tag-edit-field-option>Robert</tag-edit-field-option>
      <tag-validation rule='required'></tag-validation>
      <tag-validation rule='maxLength' args='100'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm
  inline
  submitButtonText='Save'
  submitButtonIcon='Save'
  submitButtonIconAccent='white'
  submitButtonAccent='viridiangreen'
  submitButtonAlign='left'
>
  <TagFormGroup inline>
    <TagEditField
      name="type"
      label="Type"
      editor="combobox"
      options={[
        { label: 'Fall on Same Level', value: 'Fall on Same Level' },
        { label: 'Fall from Height', value: 'Fall from Height' },
        { label: 'Struck by Moving Object', value: 'Struck by Moving Object' },
      ]}
      validation={[{ rule: 'required' }]}
      placeholder='(Select)'
      inline
    />
    <TagEditField
      name="date"
      label="Date"
      editor="datepick"
      validation={[{ rule: 'required' }]}
      inline
    />
  </TagFormGroup>
  <TagFormGroup  inline>
    <TagEditField
      name="description"
      label="Description"
      editor="multilinetextbox"
      validation={[{ rule: 'required' }, { rule: 'maxLength', args: '1000' }]}
      inline
    />
  </TagFormGroup>
  <TagFormGroup inline>
    <TagEditField
      name="reportedBy"
      editor="combobox"
      options={[
        { label: 'Bob', value: 'Bob' },
        { label: 'Jane', value: 'Jane' },
        { label: 'Robert', value: 'Robert' },
      ]}
      validation={[{ rule: 'required' }, { rule: 'maxLength', args: '100' }]}
      label="Reported By"
      placeholder='(Select)'
      inline
    />
  </TagFormGroup>
</TagForm>`,
  },
};

const footerWithClearStory: Story = {
  title: 'Footer with clear',
  description: 'An example of form with a clear button in the footer slot',
  coreComponent: {
    html: `<tag-form
  submit-button-text='Submit'
  submit-button-accent='viridiangreen'
>
  <tag-form-group>
    <tag-edit-field name='name' label='Name'>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='email' label='email' editor='email'>
    </tag-edit-field>
  </tag-form-group>
  <div slot="footer">
      <tag-button size='large' icon='Cross' text='Clear' class='clear-button'></tag-button>
  </div>
</tag-form>`,
    js: `var form = document.querySelector('tag-form');
  var clearButton = document.querySelector('.clear-button');
  clearButton.addEventListener('buttonClick', function () {
    form.clear();
  });
  `,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const form = React.useRef(null);
    return (
      <TagForm
        ref={form}
        submitButtonText='Submit'
        submitButtonAccent='viridiangreen'
      >
        <TagFormGroup>
          <TagEditField name='name' label='Name'>
          </TagEditField>
        </TagFormGroup>
        <TagFormGroup>
          <TagEditField name='email' label='email' editor='email'>
          </TagEditField>
        </TagFormGroup>
        <div slot="footer">
            <TagButton
              size='large'
              icon='Cross'
              text='Clear'
              onButtonClick={() => form.current.tagComponent.current.clear()}>
            </TagButton>
        </div>
      </TagForm>
    )
  };`,
  },
};

const submitStartingStory: Story = {
  title: 'submitStarting function',
  description:
    'The submitStarting function property is used to inject a userId into the form body submission. The submission can be cancelled by setting cancel = true in the returned object',
  coreComponent: {
    html: `<tag-form>
  <tag-form-group>
  <tag-edit-field name='comment' label='Comment'></tag-edit-field>
</tag-form-group>
</tag-form>
<tag-edit-field name='cancel' label='Tick to cancel the submission' editor='checkbox' />`,
    js: `function getUserId() {
    return "a-user-id";
  }
  var tagForm = document.querySelector('tag-form');
  tagForm.componentOnReady().then(function() {
    tagForm.submitStarting = function (values) {
      values.userId = getUserId();
      return { values, cancel: document.querySelector('tag-edit-field[name="cancel"]').value };
    };
  });`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [cancel, setCancel] = React.useState(false);
    const getUserId = () => "a-user-id";
    const handleSubmitStarting = (values) => {
      return { values, userId: getUserId(), cancel };
    }
    return (
      <React.Fragment>
        <TagForm
          submitStarting={handleSubmitStarting}
        >
          <TagFormGroup>
            <TagEditField name='comment' label='Comment'></TagEditField>
          </TagFormGroup>
        </TagForm>
        <TagEditField
          name='cancel'
          label='Tick to cancel the submission'
          editor='checkbox'
          value={cancel}
          onValueChange={e => setCancel(e.detail.value)}
        />
      </React.Fragment>
    )
  };`,
  },
};

const submitCompletetStory: Story = {
  title: 'submitComplete function',
  description:
    'The submitComplete method is used to tell the form whether the submission on the server was successful or not',
  coreComponent: {
    html: `<tag-form>
  <tag-form-group>
  <tag-edit-field name='comment' label='Comment'></tag-edit-field>
</tag-form-group>
</tag-form>
<tag-edit-field name='response' label='Server response' editor='dropdown' value='400'>
  <tag-edit-field-option value="200">Success</tag-edit-field-option>
  <tag-edit-field-option value="400">Validation error</tag-edit-field-option>
  <tag-edit-field-option value="500">Internal server error</tag-edit-field-option>
</tag-edit-field>`,
    js: `var tagForm = document.querySelector('tag-form');
  tagForm.addEventListener("submit", function (e) {

    // call the server to do the submission and get the result ...

    var status = Number(document.querySelector('tag-edit-field[name="response"]').value);
    var body = status === 400 ? {comment: ['the server says something is wrong with this comment'] } : {}

    tagForm.submitComplete({
      ok: status === 200,
      status: status,
      body
    });
  })`,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [status, setStatus] = React.useState(400)

    const handleSubmit = (e) => {
      // call the server to do the submission and get the result ...

      var body = status === 400 ? {comment: ['the server says something is wrong with this comment'] } : {}

      return {
        ok: status === 200,
        status: status,
        body
      }
    }
    return (
      <React.Fragment>
        <TagForm
          onSubmit={handleSubmit}
        >
          <TagFormGroup>
            <TagEditField name='comment' label='Comment'></TagEditField>
          </TagFormGroup>
        </TagForm>
        <TagEditField
          label='Server response'
          editor='dropdown'
          data-type='integer'
          options={[
            {label:'Success', value: 200},
            {label:'Validation error', value: 400},
            {label:'Internal server error', value: 500}
          ]}
          value={status}
          onValueChange={e => setStatus(e.detail.value)}
        />
      </React.Fragment>
    )
  };`,
  },
};

const submitButtonOutsideOfFormStory: Story = {
  title: 'Submit button outside of Form',
  description: 'An example of form with a clear button in the footer slot',
  coreComponent: {
    html: `<tag-form  submit-button-hidden="true">
  <tag-form-group>
    <tag-edit-field name='name' label='Name'>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='email' label='email' editor='email'>
    </tag-edit-field>
  </tag-form-group>
</tag-form>

<tag-button size='large' icon='Save' accent="viridiangreen" text='Submit' icon-accent='white' class='submit-button'></tag-button>`,
    js: `var form = document.querySelector('tag-form');
  var submitButton = document.querySelector('.submit-button');
  submitButton.addEventListener('buttonClick', function () {
    form.submitForm();
  });
  `,
  },

  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const form = React.useRef(null);
    return (
      <div>
      <TagForm
        ref={form}
        submitButtonHidden={true}
      >
        <TagFormGroup>
          <TagEditField name='name' label='Name'>
          </TagEditField>
        </TagFormGroup>
        <TagFormGroup>
          <TagEditField name='email' label='email' editor='email'>
          </TagEditField>
        </TagFormGroup>
      </TagForm>
      <TagButton
        size='large'
        text='Submit'
        icon='Save'
        accent='viridiangreen'
        iconAccent='white'
        onButtonClick={() => form.current.tagComponent.current.submitForm()}>
      </TagButton>
  </div>
    )
  };`,
  },
};

export const TagFormDocs: Component = {
  type: 'component',
  name: 'form',
  description: 'Renders a form with a submit button that typically wraps tag-edit-fields',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'inline',
      description: 'Whether the form fields are inline',
      type: 'boolean',
    },
    {
      name: 'submitButtonText',
      description: 'The text on the submit button',
      type: 'string',
      default: 'Submit',
    },
    {
      name: 'submitButtonIcon',
      description: 'The icon on the submit button',
      type: 'string',
      default: '',
    },
    {
      name: 'submitButtonDisabled',
      description: 'The enabled state for the submit button',
      type: 'boolean',
      default: 'false',
    },
    {
      name: 'submitButtonAccent',
      description: 'The accent colour for the submit button',
      type: 'string',
      default: 'Access',
    },
    {
      name: 'submitButtonAlign',
      description: 'The alignment of the submit button',
      type: 'left | right | center',
      default: 'left',
    },
    {
      name: 'submitButtonStyle',
      description: 'CSS JSON style for the submit button',
      type: 'string',
    },
    {
      name: 'submitSuccessMessage',
      description: 'The message displayed when the data has been successfully submitted',
      type: 'string',
      default: 'The information was successfully saved!',
    },
    {
      name: 'submitFailureMessage',
      description:
        'The message displayed when an unexpected problem has occurred submitting the data',
      type: 'string',
      default: 'Sorry, an unexpected error has occurred',
    },
    {
      name: 'submitValidationMessage',
      description:
        'The message displayed when a validation problem has occurred submitting the data',
      type: 'string',
      default: 'Sorry, some of the information is invalid. Please review, adjust and try again',
    },
    {
      name: 'submitStarting',
      description:
        'A function that can be called when the submission process starts. You can use this to set any additional values or cancel the submission process',
      type: '(values: IFormValues) => Promise<{values: IFormValues, cancel: boolean}>',
    },
    {
      name: 'serverValidationMapper',
      description:
        'A function that maps server validation errors to IFormErrors which is the format this component expects',
      type: '(response: IHttpResponse, fieldNames: string[]) => IFormErrors',
      default: 'A function which maps ASP.NET validation errors',
    },
    {
      name: 'formStyle',
      description: 'JSX style object in JSON to apply',
      type: 'string',
      default: '',
    },
    {
      name: 'submitButtonHidden',
      description: 'Whether the submit button is visible',
      type: 'boolean',
      default: 'false',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'submit',
      description: 'Raised when a form is submitted',
      parameters: [
        {
          name: 'body',
          description: 'Object containing all the field values',
          type: 'IFormValues - {field1: value1, field2: value2, ...}',
        },
      ],
    },
  ],
  methods: [
    {
      name: 'getFieldValues',
      description: 'Returns all the field values from the tag-edit-field components on the form',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'getFieldValue',
      description: 'Returns the field value for the given tag-edit-field component',
      parameters: [
        {
          name: 'fieldName',
          type: 'string',
          description: 'The name attribute for the tag-edit-field component to get the value for',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setFieldValues',
      description: 'Sets the values for the given ag-edit-field components',
      parameters: [
        {
          name: 'values',
          description:
            'An object containing the new values. The property name in the object must match the name attribute on the tag-edit-field component',
          type: 'string[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setFieldValue',
      description: 'Sets the value for the given ag-edit-field component',
      parameters: [
        {
          name: 'fieldName',
          description: 'The name attribute for the tag-edit-field component to set the value on',
          type: 'string',
        },
        {
          name: 'value',
          description: 'The value to set on the tag-edit-field component',
          type: 'string',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'setError',
      description: 'Set a validation error on the given ag-edit-field component',
      parameters: [
        {
          name: 'fieldName',
          description:
            'The name attribute for the tag-edit-field component to set the validation error on',
          type: 'string',
        },
        {
          name: 'errors',
          description: 'An array validation errors to set',
          type: 'string[]',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'submitComplete',
      description: 'Allows the result of the submission to be pushed in this form',
      parameters: [
        {
          name: 'response',
          description: 'The response from the web API call',
          type: 'IHttpResponse: {headers?: Headers, status?: number, ok?: boolean, body?: any}',
        },
      ],
      returnType: 'void',
    },
    {
      name: 'clear',
      description:
        'Empties all tag-edit-field components on the form, clears the errors and re-enables the submit button',
      parameters: [],
      returnType: 'void',
    },
    {
      name: 'submitForm',
      description: 'submit function for submit button outside the form',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [
    StandardStory,
    InlineStory,
    footerWithClearStory,
    submitStartingStory,
    submitCompletetStory,
    submitButtonOutsideOfFormStory,
  ],
};
